export const PARTICIPANT_COLORS = [
  '#1565C0', '#C62828', '#2E7D32', '#6A1B9A', '#EF6C00',
  '#00838F', '#AD1457', '#4527A0', '#558B2F', '#D84315',
  '#0277BD', '#9E9D24', '#5D4037', '#00695C', '#7B1FA2',
];

export function formatGrade(value) {
  const numeric = Number(value);
  return Number.isFinite(numeric)
    ? numeric.toLocaleString('de-DE', { minimumFractionDigits: Number.isInteger(numeric) ? 0 : 2, maximumFractionDigits: 2 })
    : 'Nicht bewertet';
}

export function buildInitialFullDuplexValues(config, savedValues = {}) {
  return Object.fromEntries(
    (config?.deviceGroups || []).flatMap((group) => group.criteria)
      .map((criterion) => [criterion.key, savedValues[criterion.key] ?? null]),
  );
}

export function hasAnyFullDuplexScore(values) {
  return Object.values(values || {}).some((value) => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 6);
}

export function buildFullDuplexFormUrl(origin) {
  return `${String(origin || '').replace(/\/+$/, '')}/rueckmeldung/testbetrieb-vollduplexfunk?section=form`;
}

export function getParticipantPalette(submissions = []) {
  return Object.fromEntries(
    [...submissions]
      .sort((left, right) => String(left.userName || '').localeCompare(String(right.userName || ''), 'de'))
      .map((submission, index) => [
        Number(submission.id),
        PARTICIPANT_COLORS[index % PARTICIPANT_COLORS.length],
      ]),
  );
}

function average(values) {
  const scores = values.map(Number).filter(Number.isFinite);
  return scores.length
    ? Number((scores.reduce((sum, score) => sum + score, 0) / scores.length).toFixed(2))
    : null;
}

export function buildIndividualAnalysis(config, submission) {
  const values = submission?.values || {};
  const devices = Object.fromEntries((config?.deviceGroups || []).map((group) => {
    const scores = group.criteria.map((criterion) => values[criterion.key]).filter((value) => value != null);
    return [group.key, { average: average(scores), responseCount: scores.length, markers: [] }];
  }));
  const criteria = Object.fromEntries((config?.deviceGroups || []).flatMap((group) => group.criteria).map((criterion) => [
    criterion.key,
    {
      average: values[criterion.key] ?? null,
      responseCount: values[criterion.key] == null ? 0 : 1,
      markers: [],
    },
  ]));
  return {
    submissionCount: submission ? 1 : 0,
    overall: {
      average: average(Object.values(values).filter((value) => value != null)),
      responseCount: Object.values(values).filter((value) => value != null).length,
      markers: [],
    },
    devices,
    criteria,
  };
}
